import { ResolveFn } from '@angular/router';
import { SERVICE_CHUNKS, VESSEL_CHUNKS, vesselChunk } from './sealanes-chunks';
import { SealanesHub, SealanesServiceRecord, SealanesVesselRecord } from './sealanes-types';

// Resolvers, not ngOnInit: the router waits for them, so server rendering always has the data.
// Each page loads only its own lazy chunk; the routes' canMatch has already checked the slug exists.

export const sealanesHubResolver: ResolveFn<SealanesHub> = () => import('./data/hub').then(m => m.HUB);

// sealanes-copy is imported on demand so the Sealanes index stays out of the main bundle.
export const sealanesServiceResolver: ResolveFn<SealanesServiceRecord | undefined> = async route => {
  const { serviceChunkFor } = await import('./sealanes-copy');
  const slug = route.paramMap.get('slug') ?? '';
  const chunk = serviceChunkFor(slug);
  const load = chunk ? SERVICE_CHUNKS[chunk] : undefined;
  return (load?.() ?? Promise.resolve([])).then(list => list.find(s => s.slug === slug));
};

export const sealanesVesselResolver: ResolveFn<SealanesVesselRecord | undefined> = route => {
  const slug = route.paramMap.get('slug') ?? '';
  const load = VESSEL_CHUNKS[vesselChunk(slug)];
  return (load?.() ?? Promise.resolve([])).then(list => list.find(v => v.slug === slug));
};
